import 'lib/suppress_resize_observer_error';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Rails from '@rails/ujs';
Rails.start();

// Import and set moment globally first
import moment from 'moment';
global.moment = moment;
window.moment = moment;

// Then load other dependencies
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import '../components';

import { enableDynamicTooltips } from 'shared/dynamic_tooltips';
import { enableDynamicPopovers } from 'shared/popovers';
import { enableInputMasks } from 'shared/input_mask';
import { enableModalCleanup } from 'shared/modal_cleanup';
import { fadeOut, fadeIn } from 'shared/fade';
import { row, leaving } from 'shared/highlight';
import { enableForm, resetForm } from 'shared/form';
import { show, hide, hideAll } from 'shared/modal';
import { initSidebar } from 'shared/sidebar';
import { registerNotificationApp } from 'shared/notifications';
import { initPageComponents } from 'shared/page_setup';

enableDynamicTooltips();
enableDynamicPopovers();
enableInputMasks();
enableModalCleanup();
registerNotificationApp();
window.daModal = { show, hide, hideAll };
window.daFade = { out: fadeOut, in: fadeIn };
window.daHighlight = { row, leaving };
window.daForm = { enable: enableForm, reset: resetForm };

document.addEventListener('DOMContentLoaded', () => {
  initSidebar();
  initPageComponents();
});

require.context('../packs/images', true, /\.(svg|png|jpe?g|gif)$/i);
